import Superscript from "@/components/ui/superscript";
export const keyFacts = [
  {
    title: <>Number of internal migrants</>,
    description: (
      <>
        140 million internal migrants move for work{" "}
        <Superscript
          path="https://link.springer.com/article/10.1007/s41027-020-00293-8"
          index="1"
        />
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    title: <>Migration trends</>,
    description: (
      <>
        62% migrants move from rural to rural areas followed by 20% migrating
        from rural to urban{" "}
        <Superscript
          path="https://www.knomad.org/sites/default/files/2021-02/Policy%20Brief%20-%20Internal%20Migrationand%20Urbanization%20-%20India%20Policy%20Brief%2012%20Feb%202021.pdf"
          index="2"
        />
      </>
    ),
    icon: "/images/icons/urbanization.png",
  },
  {
    title: <>Key destination areas</>,
    description: (
      <>
        <Superscript
          path="https://prsindia.org/theprsblog/migration-in-india-and-the-impact-of-the-lockdown-on-migrants"
          index="3"
        />{" "}
        Maharashtra, Delhi and Gujarat
      </>
    ),
    icon: "/images/icons/destination (2).png",
  },
  {
    title: <>Prominent sectors of employment for migrants </>,
    description: (
      <>
        <Superscript
          path="https://www.mospi.gov.in/sites/default/files/publication_reports/533_final.pdf"
          index="4"
        />{" "}
        construction sector, agriculture and manufacturing sector
      </>
    ),
    icon: "/images/icons/job.png",
  },
];
export const climateImpacts = [
  {
    description: (
      <>
        There are 14 million
        <Superscript
          path="https://actionaid.org/sites/default/files/publications/ActionAid%20CANSA%20-%20South%20Asia%20Climate%20Migration%20report%20-%20Dec%202020_3.pdf"
          index="6"
        />{" "}
        estimated climate migrants in the country. An estimated 45 million
        people are predicted to migrate by 2050 as a result of climate change
        <Superscript
          path="https://cansouthasia.net/wp-content/uploads/2021/02/Migration_India_20_02_2021.pdf"
          index="7"
        />
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    description: (
      <>
        Seasonal migration is a primary coping strategy for a large rural
        population faced with agricultural distress. This is driven by a
        combination of economic and climate-related factors.
      </>
    ),
    icon: "/images/icons/season.png",
  },
  {
    description: (
      <>
        Climate change impacts are experienced in destination areas as well.
        Migrants at destination locations usually reside in areas which are
        already prone to climate related impact.
      </>
    ),
    icon: "/images/icons/climate-change.png",
  },
  {
    description: (
      <>
        Top three impacts at source on livelihoods in India are wage loss (57%),
        wage cuts (56%) and crop loss (43%), and household impacts are food
        insecurity (41%), health issues (41%) and house damage (37%). (Sample
        size - 7340)
      </>
    ),
    icon: "/images/icons/impact.png",
  },
  {
    description: (
      <>
        Top three impacts at destination on livelihoods are wage loss (72%) ,
        wage cut (56%) and job loss (31%), and household impacts are health
        issues (59%), food insecurity (45%) and house damage (33%). (Sample size
        - 1135)
      </>
    ),
    icon: "/images/icons/home.png",
  },
];
export const stories = [
  {
    title: "Raging Rivers: Rebuilding After Floods",
    description: "",
    videoPath: "https://youtu.be/IS1i0j1QvNM",
  },
  {
    title: "Moving for Scraps: The Migrant Struggle",
    description: "",
    videoPath: "https://youtu.be/wWkHy1HcZos",
  },
];

export const partners = [
  {
    link: "#",
    title: "Lorem Ipsum",
    logo: "/images/product-list.svg",
  },
  {
    link: "#",
    title: "Lorem Ipsum",
    logo: "/images/product-list.svg",
  },
  {
    link: "#",
    title: "Lorem Ipsum",
    logo: "/images/product-list.svg",
  },
  {
    link: "#",
    title: "Lorem Ipsum",
    logo: "/images/product-list.svg",
  },
];

export const seo = {
  slug: "/india",
  metaTitle: "India | People’s Courage International, South & Southeast Asia",
  metaDescription:
    "PCI operates three initiatives in India: Migrants Resilience Collaborative, Grassroots Resilience Institute and the climate resilience initiative.",
};

export const jsonLd = {
  "@context": "http://www.schema.org",
  "@type": "Organization",
  name: "People’s Courage International",
  description:
    "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "3206 10th Street NE, Washington",
    addressLocality: "DC",
    postalCode: "20017",
    addressCountry: "USA",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1202-573-8727",
    contactType: "customer support",
  },
};
